import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

import { Outlet } from '../navigation'
import { LoadingModal } from '../components/Modal'
import { useExternal } from './'

export default function ExternalMenu() {
    const { t } = useTranslation()

    const { isLoading } = useExternal()

    return (
        <>
            {/* @ts-ignore */}
            <Helmet>
                <title>{t('external')} | Patent Cockpit</title>
            </Helmet>
            {isLoading
                ? <LoadingModal />
                : <Outlet />}
        </>
    )
}
